const iFrameResize = require('@iframe-resizer/parent');

(function () {
  var HTTP_URL_FORMAT = /^https?:\/\//i;

  if (typeof window.ODSignupFormEmbed === "function") {
    return;
  }

  window.ODSignupFormEmbed = function (iframeID) {
    var iframe = document.getElementById(iframeID);

    window.addEventListener("message", function (event) {
      var payload = event.data;

      if (event.source !== iframe.contentWindow) return;
      if (!payload || typeof payload !== "object" || payload.from !== "PublicSignupForm") return;
      if (payload.command !== "opendateSignupFormRedirect") return;

      var url = payload.data && payload.data.url;
      if (typeof url === "string" && HTTP_URL_FORMAT.test(url)) {
        window.location.href = url;
      }
    });

    iFrameResize({ license: "12ajjdewwwy-26rnhw2943-1s7g1u8ma0i" }, iframe);
  };
})();
